<template>
  <q-table
    flat
    dense
    :rows="rows"
    :columns="columns"
    row-key="date"
    bordered
    :rows-per-page-options="[31]"
    separator="cell"
    :no-data-label="$t('messages.no_data_available')"
    class="overview-table"
  >
    <template v-slot:top>
      <div>
        <p class="q-ma-none text-h6 text-weight-medium">{{ title }}</p>
        <p v-if="description" class="q-ma-none text-grey-7 text-body2">{{ description }}</p>
      </div>
    </template>

    <template v-slot:header="props">
      <q-tr :props="props">
        <q-th v-for="col in props.cols" :key="col.name" :props="props" class="text-bold column-separator">
          {{ col.label }}
        </q-th>
      </q-tr>

      <q-tr v-if="summaryRow">
        <q-td
          v-for="col in columns"
          :key="col.name"
          class="bg-grey-4 text-bold z-index-1 column-separator"
          :style="{ textAlign: col.align }"
        >
          {{ col.name === 'date' ? '期間合計' : formatValue(col, summaryRow[col.name] || 0) }}
        </q-td>
      </q-tr>
    </template>
  </q-table>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { IOverviewMessage } from '@/utils/types'
import { ITableColumn } from '@/utils/table'

@Options({})
export default class BaseTableComponent extends Vue {
  @Prop({ type: String, required: true })
  title!: string

  @Prop()
  description!: string

  @Prop({ type: Array, default: () => [] })
  rows!: IOverviewMessage[]

  @Prop({ type: Array, required: true })
  columns!: ITableColumn[]

  @Prop({ type: Object })
  summaryRow?: Record<string, number>

  initialPagination = {
    sortBy: 'desc',
    descending: false,
    page: 1,
    rowsPerPage: 31,
  }

  formatValue(column: ITableColumn, value: any): string {
    if (value === undefined || value === null) return ''

    if (column.format) {
      return column.format(value) as string
    }

    return value.toString()
  }
}
</script>

<style lang="scss">
.overview-table {
  height: 100% !important;

  .column-separator {
    position: relative;
  }

  .q-table tbody td:after,
  .column-separator:after {
    content: '';
    height: 40%;
    width: 1px;
    border-radius: 10px;

    position: absolute;
    right: 0;
    left: 0;
    top: 30%;
    background-color: #b7b0b0;
  }

  .column-separator:first-child::after,
  .q-table tbody td:first-child::after {
    content: none;
  }

  // Pagination styling
  .q-table__bottom {
    background-color: #f4f4f4 !important;

    // Pagination buttons
    .q-btn {
      color: #3982c2 !important;
      opacity: 1 !important;

      &:hover {
        background-color: rgba(25, 118, 210, 0.1) !important;
      }

      &.q-btn--unelevated {
        background-color: #3982c2 !important;
        color: white !important;
      }
    }

    .q-field {
      .q-field__control {
        color: #3982c2 !important;
      }

      .q-field__native {
        color: #3982c2 !important;
      }
    }

    .q-table__bottom-nodata {
      color: #3982c2 !important;
    }
  }
}
</style>
